import type { Locale } from './types'

const homePaths: Record<Locale, string> = {
  ar: '/',
  en: '/en/',
}

export function pagePath(locale: Locale, page: 'home') {
  return page === 'home' ? homePaths[locale] : homePaths[locale]
}

export function localeFromPath(pathname: string): Locale {
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'ar'
}

export function alternatePath(pathname: string) {
  return localeFromPath(pathname) === 'ar' ? homePaths.en : homePaths.ar
}
